import { useMemo } from 'react'

export const useEnvFeatures = env => {
  return useMemo(() => {
    return Object.entries(env).reduce((list, [name, value]) => {
      if (name.includes('FEATURE_') && value.toString() === '1') {
        list.push(name.replace(/FEATURE_/, ''))
      }
      return list
    }, [])
  }, [env])
}
